import SortList from './sort-list';
export default {
  name: 'WeSortPanel',
  components: {
    SortList
  },
  props: {
    /**
     * 待排序列表
     */
    value: {
      type: Array,
      default: () => []
    },

    /**
     * 显示的文字
     */
    title: {
      type: String,
      default: '自定义列'
    },

    /**
     * 弹出层的宽度
     */
    popWidth: {
      type: Number,
      default: 400
    },

    /**
     * 控件展示列数
     */
    col: {
      type: Number,
      default: 4
    },

    /**
     * 弹出层的位置，top/top-start/top-end/ bottom/bottom-start/bottom-end/ left/left-start/left-end/ right/right-start/right-end
     */
    placement: {
      type: String,
      default: 'right'
    }
  },
  data: () => ({
    show: false,
    tempData: []
  }),
  watch: {
    value(data) {
      this.tempData = data;
    }

  },

  created() {
    this.initData();
  },

  methods: {
    onChange() {
      /**
       * 数据变化时触发
       */
      this.$emit('input', this.tempData);
    },

    initData() {
      this.tempData = this.value.map(item => ({ ...item
      }));
    }

  }
};